import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/cancel.png'
import _imports_1 from '@/assets/delete.png'


const _hoisted_1 = {
  ref: "modalWordsWrap",
  class: "list__info make-words__wrapper"
}
const _hoisted_2 = {
  ref: "modalContent",
  class: "make-words"
}
const _hoisted_3 = { class: "make-words__content" }
const _hoisted_4 = { class: "make-words__header" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_7 = { class: "make-words__areas" }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "" }
const _hoisted_11 = {
  key: 2,
  class: "modal__errors-wrapper"
}
const _hoisted_12 = { class: "modal__errors" }
const _hoisted_13 = { class: "modal__message" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  ref: "footer",
  class: "make-words__footer"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_words = _resolveComponent("input-words")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.startWords.title == null)
            ? (_openBlock(), _createElementBlock("h2", {
                key: 0,
                ref: "modalTitle"
              }, _toDisplayString(_ctx.t("account.modalWords.makeList")), 513))
            : (_openBlock(), _createElementBlock("h2", {
                key: 1,
                ref: "modalTitle"
              }, _toDisplayString(_ctx.t("account.modalWords.addNewWords")), 513)),
          (_ctx.startWords.title == null)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 2,
                class: "input-focus",
                ref: "inputTitle",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.titleWords) = $event)),
                placeholder: _ctx.t('account.modalWords.nameOfDictionary'),
                type: "text"
              }, null, 8, _hoisted_5)), [
                [_vModelText, _ctx.titleWords]
              ])
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "profile__run modal__btn-image",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.modalClose && _ctx.modalClose(...args)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t("account.modalWords.close")), 1),
            _hoisted_6
          ])
        ]),
        (!_ctx.isRecording)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "make-words__button-speech profile__run",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.startRecording && _ctx.startRecording(...args)))
            }, _toDisplayString(_ctx.t('account.modalWords.recordMicro')), 1))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "make-words__button-speech profile__run",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.stopRecording && _ctx.stopRecording(...args)))
            }, _toDisplayString(_ctx.t('account.modalWords.stopMicro')), 1)),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.fieldWords.ru.length > 0)
            ? (_openBlock(), _createElementBlock("textarea", {
                key: 0,
                value: _ctx.fieldWords.ru
              }, null, 8, _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.fieldWords.en.length > 0)
            ? (_openBlock(), _createElementBlock("textarea", {
                key: 1,
                value: _ctx.fieldWords.en
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wordsList.value.length + 1, (num, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "modal__item"
            }, [
              _createVNode(_component_input_words, {
                "word-index": index,
                onSetValueInput: _ctx.setValueInput,
                len: _ctx.wordsList.value.length
              }, null, 8, ["word-index", "onSetValueInput", "len"])
            ]))
          }), 128))
        ]),
        (_ctx.incorrectWord != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.t("account.modalWords.incorrect")), 1),
                (_ctx.incorrectWord.correct != undefined)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                      _createTextVNode(_toDisplayString(_ctx.t("account.modalWords.correct")) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.incorrectWord.correct), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            type: "submit",
            ref: "sendButton",
            class: "profile__run modal-button__run modal__save modal__btn-image",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendData && _ctx.sendData(...args)))
          }, _toDisplayString(_ctx.t("account.modalWords.save")), 513),
          _createElementVNode("button", {
            ref: "resetButton",
            type: "submit",
            class: "profile__run modal__save modal__btn-image",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetData && _ctx.resetData(...args)))
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.t("account.modalWords.clean")), 1),
            _hoisted_16
          ], 512)
        ], 512)
      ])
    ], 512)
  ], 512))
}